(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["acne-pimple"] && !Shopify.designMode) return;
  try {
    
(function() {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const delay = parseInt(entry.target.dataset.delay) || 0;
        setTimeout(() => entry.target.classList.add('acn-visible'), delay);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('[data-acn-reveal]').forEach(el => observer.observe(el));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["acne-scar"] && !Shopify.designMode) return;
  try {
    
(function(){var o=new IntersectionObserver(function(e){e.forEach(function(en){if(en.isIntersecting){var el=en.target,d=0,p=el.parentElement;if(p){var s=p.querySelectorAll('[data-reveal]');s.forEach(function(x,i){if(x===el)d=i*80})}setTimeout(function(){el.classList.add('acn-vis')},Math.min(d,400));o.unobserve(el)}})},{threshold:.08});document.querySelectorAll('[data-reveal]').forEach(function(el){o.observe(el)})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["acne-treatment"] && !Shopify.designMode) return;
  try {
    
/* JS inline */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ageing-issues"] && !Shopify.designMode) return;
  try {
    
(function(){
  var els=document.querySelectorAll('[data-reveal]');
  if(!els.length)return;
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){els.forEach(function(e){e.classList.add('age-visible')});return}
  var io=new IntersectionObserver(function(entries){entries.forEach(function(en){if(en.isIntersecting){en.target.classList.add('age-visible');io.unobserve(en.target)}})},{threshold:0.08});
  els.forEach(function(e){io.observe(e)});

  document.querySelectorAll('.age-faq__q').forEach(function(btn){
    btn.addEventListener('click',function(){
      var item=btn.closest('.age-faq__item');var answer=item.querySelector('.age-faq__a');var isOpen=item.classList.contains('age-faq__item--open');
      document.querySelectorAll('.age-faq__item--open').forEach(function(o){o.classList.remove('age-faq__item--open');o.querySelector('.age-faq__q').setAttribute('aria-expanded','false');o.querySelector('.age-faq__a').style.maxHeight='0'});
      if(!isOpen){item.classList.add('age-faq__item--open');btn.setAttribute('aria-expanded','true');answer.style.maxHeight=answer.scrollHeight+'px'}
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["allodermis-landing-2"] && !Shopify.designMode) return;
  try {
    
/* Placeholder — all JS is inline <script> for reliability */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["allopecia"] && !Shopify.designMode) return;
  try {
    
(function(){
  var els=document.querySelectorAll('[data-reveal]');if(!els.length)return;
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){els.forEach(function(e){e.classList.add('alp-visible')});return}
  var io=new IntersectionObserver(function(entries){entries.forEach(function(en){if(en.isIntersecting){en.target.classList.add('alp-visible');io.unobserve(en.target)}})},{threshold:0.08});
  els.forEach(function(e){io.observe(e)});
  document.querySelectorAll('.alp-faq__q').forEach(function(btn){
    btn.addEventListener('click',function(){
      var item=btn.closest('.alp-faq__item'),answer=item.querySelector('.alp-faq__a'),isOpen=item.classList.contains('alp-faq__item--open');
      document.querySelectorAll('.alp-faq__item--open').forEach(function(o){o.classList.remove('alp-faq__item--open');o.querySelector('.alp-faq__q').setAttribute('aria-expanded','false');o.querySelector('.alp-faq__a').style.maxHeight='0'});
      if(!isOpen){item.classList.add('alp-faq__item--open');btn.setAttribute('aria-expanded','true');answer.style.maxHeight=answer.scrollHeight+'px'}
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article-allodermis"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.ar-wrap').forEach(function(wrap){
    var content = wrap.querySelector('[id^="ar-content-"]');
    var tocList = wrap.querySelector('[id^="ar-toc-"]');
    var progressBar = wrap.querySelector('[id^="ar-progress-bar-"]');
    if (!content) return;
    // Build TOC from H2s
    var h2s = content.querySelectorAll('h2');
    if (tocList && h2s.length > 1) {
      h2s.forEach(function(h, i){
        if (!h.id) h.id = 'h-' + (h.textContent || '').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'').slice(0,60) + '-' + i;
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id; a.textContent = h.textContent || '';
        li.appendChild(a); tocList.appendChild(li);
      });
    } else if (tocList) {
      tocList.parentElement.style.display = 'none';
    }
    // Reading progress
    if (progressBar) {
      var article = wrap.querySelector('.ar-body');
      function update(){
        if (!article) return;
        var rect = article.getBoundingClientRect();
        var viewportH = window.innerHeight || document.documentElement.clientHeight;
        var scrolled = -rect.top;
        var total = rect.height - viewportH;
        var pct = Math.min(100, Math.max(0, (scrolled / Math.max(1, total)) * 100));
        progressBar.style.width = pct + '%';
      }
      window.addEventListener('scroll', update, {passive: true});
      window.addEventListener('resize', update);
      update();
    }
    // Active TOC item on scroll
    if (tocList && 'IntersectionObserver' in window) {
      var tocLinks = tocList.querySelectorAll('a');
      var obs = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (e.isIntersecting) {
            tocLinks.forEach(function(l){ l.classList.toggle('is-active', l.getAttribute('href') === '#' + e.target.id); });
          }
        });
      }, {rootMargin: '-40% 0px -55% 0px'});
      h2s.forEach(function(h){ obs.observe(h); });
    }
    // Copy share
    var copyBtn = wrap.querySelector('.ar-share__copy');
    if (copyBtn && navigator.clipboard) {
      copyBtn.addEventListener('click', function(){
        navigator.clipboard.writeText(copyBtn.dataset.url || location.href).then(function(){
          var orig = copyBtn.innerHTML;
          copyBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>';
          setTimeout(function(){ copyBtn.innerHTML = orig; }, 1600);
        });
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["birthmarks-moles"] && !Shopify.designMode) return;
  try {
    
(function(){
  var els=document.querySelectorAll('[data-reveal]');if(!els.length)return;
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){els.forEach(function(e){e.classList.add('bmk-visible')});return}
  var io=new IntersectionObserver(function(entries){entries.forEach(function(en){if(en.isIntersecting){en.target.classList.add('bmk-visible');io.unobserve(en.target)}})},{threshold:0.08});
  els.forEach(function(e){io.observe(e)});
  document.querySelectorAll('.bmk-faq__q').forEach(function(btn){
    btn.addEventListener('click',function(){
      var item=btn.closest('.bmk-faq__item'),answer=item.querySelector('.bmk-faq__a'),isOpen=item.classList.contains('bmk-faq__item--open');
      document.querySelectorAll('.bmk-faq__item--open').forEach(function(o){o.classList.remove('bmk-faq__item--open');o.querySelector('.bmk-faq__q').setAttribute('aria-expanded','false');o.querySelector('.bmk-faq__a').style.maxHeight='0'});
      if(!isOpen){item.classList.add('bmk-faq__item--open');btn.setAttribute('aria-expanded','true');answer.style.maxHeight=answer.scrollHeight+'px'}
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["black-peel-service"] && !Shopify.designMode) return;
  try {
    
/* JS inline */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["botox"] && !Shopify.designMode) return;
  try {
    
(function(){
  var targets = document.querySelectorAll('[data-reveal]');
  if (!('IntersectionObserver' in window)) { targets.forEach(function(t){ t.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, {rootMargin:'0px 0px -8% 0px', threshold:.08});
  targets.forEach(function(t){ io.observe(t); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chemical-peel"] && !Shopify.designMode) return;
  try {
    
(function(){
  var targets = document.querySelectorAll('[data-reveal]');
  if (!('IntersectionObserver' in window)) { targets.forEach(function(t){ t.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, {rootMargin:'0px 0px -8% 0px', threshold:.08});
  targets.forEach(function(t){ io.observe(t); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dark-circle"] && !Shopify.designMode) return;
  try {
    
(function(){
  var els = document.querySelectorAll('[data-reveal]');
  if(!els.length) return;
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){
    els.forEach(function(e){ e.classList.add('dkc-visible'); });
    return;
  }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      if(en.isIntersecting){
        en.target.classList.add('dkc-visible');
        io.unobserve(en.target);
      }
    });
  },{ threshold: 0.08 });
  els.forEach(function(e){ io.observe(e); });

  document.querySelectorAll('.dkc-faq__q').forEach(function(btn){
    btn.addEventListener('click', function(){
      var item = btn.closest('.dkc-faq__item');
      var answer = item.querySelector('.dkc-faq__a');
      var isOpen = item.classList.contains('dkc-faq__item--open');
      document.querySelectorAll('.dkc-faq__item--open').forEach(function(o){
        o.classList.remove('dkc-faq__item--open');
        o.querySelector('.dkc-faq__q').setAttribute('aria-expanded','false');
        o.querySelector('.dkc-faq__a').style.maxHeight = '0';
      });
      if(!isOpen){
        item.classList.add('dkc-faq__item--open');
        btn.setAttribute('aria-expanded','true');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dermal-fillers"] && !Shopify.designMode) return;
  try {
    
(function(){
  var targets = document.querySelectorAll('[data-reveal]');
  if (!('IntersectionObserver' in window)) { targets.forEach(function(t){ t.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, {rootMargin:'0px 0px -8% 0px', threshold:.08});
  targets.forEach(function(t){ io.observe(t); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["double-chin"] && !Shopify.designMode) return;
  try {
    
(function(){
  var els=document.querySelectorAll('[data-reveal]');if(!els.length)return;
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){els.forEach(function(e){e.classList.add('dcn-visible')});return}
  var io=new IntersectionObserver(function(entries){entries.forEach(function(en){if(en.isIntersecting){en.target.classList.add('dcn-visible');io.unobserve(en.target)}})},{threshold:0.08});
  els.forEach(function(e){io.observe(e)});
  document.querySelectorAll('.dcn-faq__q').forEach(function(btn){
    btn.addEventListener('click',function(){
      var item=btn.closest('.dcn-faq__item'),answer=item.querySelector('.dcn-faq__a'),isOpen=item.classList.contains('dcn-faq__item--open');
      document.querySelectorAll('.dcn-faq__item--open').forEach(function(o){o.classList.remove('dcn-faq__item--open');o.querySelector('.dcn-faq__q').setAttribute('aria-expanded','false');o.querySelector('.dcn-faq__a').style.maxHeight='0'});
      if(!isOpen){item.classList.add('dcn-faq__item--open');btn.setAttribute('aria-expanded','true');answer.style.maxHeight=answer.scrollHeight+'px'}
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["facial-hair-removal"] && !Shopify.designMode) return;
  try {
    
/* JS is inline <script> */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hifu"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.currentScript && document.currentScript.closest ? document.currentScript.closest('.hfu-wrap') : null;
  var scope = root || document;
  var targets = scope.querySelectorAll ? scope.querySelectorAll('[data-reveal]') : document.querySelectorAll('[data-reveal]');
  if (!('IntersectionObserver' in window)) {
    targets.forEach(function(t){ t.classList.add('is-in'); });
    return;
  }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, {rootMargin:'0px 0px -8% 0px', threshold:.08});
  targets.forEach(function(t){ io.observe(t); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["laser-beard-shaping"] && !Shopify.designMode) return;
  try {
    
/* JS inline */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["laser-bikini"] && !Shopify.designMode) return;
  try {
    
/* JS inline */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["laser-jair-reduction"] && !Shopify.designMode) return;
  try {
    
/* JS is inline <script> for reliability */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["melasma"] && !Shopify.designMode) return;
  try {
    
(function(){
  var els = document.querySelectorAll('.mls-root [data-reveal]');
  if(!('IntersectionObserver' in window)){ els.forEach(function(e){e.classList.add('mls-in')}); return; }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('mls-in'); io.unobserve(en.target); } });
  },{threshold:.12, rootMargin:'0px 0px -60px 0px'});
  els.forEach(function(e){ io.observe(e); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mnrf-services"] && !Shopify.designMode) return;
  try {
    
/* JS inline */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["open-pores"] && !Shopify.designMode) return;
  try {
    
(function(){
  /* Scroll reveal */
  var els = document.querySelectorAll('[data-reveal]');
  if(!els.length) return;
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){
    els.forEach(function(e){ e.classList.add('opn-visible'); });
    return;
  }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      if(en.isIntersecting){
        en.target.classList.add('opn-visible');
        io.unobserve(en.target);
      }
    });
  },{ threshold: 0.08 });
  els.forEach(function(e){ io.observe(e); });

  /* FAQ accordion */
  document.querySelectorAll('.opn-faq__q').forEach(function(btn){
    btn.addEventListener('click', function(){
      var item = btn.closest('.opn-faq__item');
      var answer = item.querySelector('.opn-faq__a');
      var isOpen = item.classList.contains('opn-faq__item--open');

      /* close all */
      document.querySelectorAll('.opn-faq__item--open').forEach(function(o){
        o.classList.remove('opn-faq__item--open');
        o.querySelector('.opn-faq__q').setAttribute('aria-expanded','false');
        o.querySelector('.opn-faq__a').style.maxHeight = '0';
      });

      if(!isOpen){
        item.classList.add('opn-faq__item--open');
        btn.setAttribute('aria-expanded','true');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-doctors"] && !Shopify.designMode) return;
  try {
    
(function(){
  var els=document.querySelectorAll('[data-reveal]');if(!els.length)return;
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){els.forEach(function(e){e.classList.add('dnm-visible')});return}
  var io=new IntersectionObserver(function(entries){entries.forEach(function(en){if(en.isIntersecting){en.target.classList.add('dnm-visible');io.unobserve(en.target)}})},{threshold:0.08});
  els.forEach(function(e){io.observe(e)});

  document.querySelectorAll('.dnm-faq__q').forEach(function(btn){
    btn.addEventListener('click',function(){
      var item=btn.closest('.dnm-faq__item'),answer=item.querySelector('.dnm-faq__a'),isOpen=item.classList.contains('dnm-faq__item--open');
      document.querySelectorAll('.dnm-faq__item--open').forEach(function(o){o.classList.remove('dnm-faq__item--open');o.querySelector('.dnm-faq__q').setAttribute('aria-expanded','false');o.querySelector('.dnm-faq__a').style.maxHeight='0'});
      if(!isOpen){item.classList.add('dnm-faq__item--open');btn.setAttribute('aria-expanded','true');answer.style.maxHeight=answer.scrollHeight+'px'}
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pimple-acne-scar"] && !Shopify.designMode) return;
  try {
    
/* JS inline */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["service-page"] && !Shopify.designMode) return;
  try {
    
(function(){var root=document.currentScript&&document.currentScript.parentElement;var wraps=document.querySelectorAll('.sp-wrap');wraps.forEach(function(w){var els=w.querySelectorAll('[data-reveal]');if(!els.length)return;if(window.matchMedia('(prefers-reduced-motion:reduce)').matches){els.forEach(function(e){e.classList.add('sp-revealed')});return}var io=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('sp-revealed');io.unobserve(e.target)}})},{threshold:0.08,rootMargin:'0px 0px -40px 0px'});els.forEach(function(e){io.observe(e)})});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skin-pigmentation"] && !Shopify.designMode) return;
  try {
    
(function(){
  var els = document.querySelectorAll('[data-reveal]');
  if(!els.length) return;
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){
    els.forEach(function(e){ e.classList.add('spg-visible'); });
    return;
  }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      if(en.isIntersecting){ en.target.classList.add('spg-visible'); io.unobserve(en.target); }
    });
  },{ threshold: 0.08 });
  els.forEach(function(e){ io.observe(e); });

  document.querySelectorAll('.spg-faq__q').forEach(function(btn){
    btn.addEventListener('click', function(){
      var item = btn.closest('.spg-faq__item');
      var answer = item.querySelector('.spg-faq__a');
      var isOpen = item.classList.contains('spg-faq__item--open');
      document.querySelectorAll('.spg-faq__item--open').forEach(function(o){
        o.classList.remove('spg-faq__item--open');
        o.querySelector('.spg-faq__q').setAttribute('aria-expanded','false');
        o.querySelector('.spg-faq__a').style.maxHeight = '0';
      });
      if(!isOpen){
        item.classList.add('spg-faq__item--open');
        btn.setAttribute('aria-expanded','true');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skin-tightening"] && !Shopify.designMode) return;
  try {
    
(function(){var els=document.querySelectorAll('.skt-root [data-reveal]');if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('skt-in')});return;}var io=new IntersectionObserver(function(entries){entries.forEach(function(en){if(en.isIntersecting){en.target.classList.add('skt-in');io.unobserve(en.target);}});},{threshold:.12,rootMargin:'0px 0px -60px 0px'});els.forEach(function(e){io.observe(e);});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stretch-marks"] && !Shopify.designMode) return;
  try {
    
(function(){
  var els=document.querySelectorAll('[data-reveal]');if(!els.length)return;
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){els.forEach(function(e){e.classList.add('stm-visible')});return}
  var io=new IntersectionObserver(function(entries){entries.forEach(function(en){if(en.isIntersecting){en.target.classList.add('stm-visible');io.unobserve(en.target)}})},{threshold:0.08});
  els.forEach(function(e){io.observe(e)});
  document.querySelectorAll('.stm-faq__q').forEach(function(btn){
    btn.addEventListener('click',function(){
      var item=btn.closest('.stm-faq__item'),answer=item.querySelector('.stm-faq__a'),isOpen=item.classList.contains('stm-faq__item--open');
      document.querySelectorAll('.stm-faq__item--open').forEach(function(o){o.classList.remove('stm-faq__item--open');o.querySelector('.stm-faq__q').setAttribute('aria-expanded','false');o.querySelector('.stm-faq__a').style.maxHeight='0'});
      if(!isOpen){item.classList.add('stm-faq__item--open');btn.setAttribute('aria-expanded','true');answer.style.maxHeight=answer.scrollHeight+'px'}
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tanned-skin"] && !Shopify.designMode) return;
  try {
    
(function(){
  var els = document.querySelectorAll('[data-reveal]');
  if(!els.length) return;
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){
    els.forEach(function(e){ e.classList.add('tan-visible'); });
    return;
  }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      if(en.isIntersecting){
        en.target.classList.add('tan-visible');
        io.unobserve(en.target);
      }
    });
  },{ threshold: 0.08 });
  els.forEach(function(e){ io.observe(e); });

  document.querySelectorAll('.tan-faq__q').forEach(function(btn){
    btn.addEventListener('click', function(){
      var item = btn.closest('.tan-faq__item');
      var answer = item.querySelector('.tan-faq__a');
      var isOpen = item.classList.contains('tan-faq__item--open');
      document.querySelectorAll('.tan-faq__item--open').forEach(function(o){
        o.classList.remove('tan-faq__item--open');
        o.querySelector('.tan-faq__q').setAttribute('aria-expanded','false');
        o.querySelector('.tan-faq__a').style.maxHeight = '0';
      });
      if(!isOpen){
        item.classList.add('tan-faq__item--open');
        btn.setAttribute('aria-expanded','true');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["treatment-for-legs"] && !Shopify.designMode) return;
  try {
    
/* JS inline */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["underarm-laser-hair-removal"] && !Shopify.designMode) return;
  try {
    
/* JS inline */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wrinkle-treatment"] && !Shopify.designMode) return;
  try {
    
(function(){
  var els=document.querySelectorAll('[data-reveal]');if(!els.length)return;
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){els.forEach(function(e){e.classList.add('wrk-visible')});return}
  var io=new IntersectionObserver(function(entries){entries.forEach(function(en){if(en.isIntersecting){en.target.classList.add('wrk-visible');io.unobserve(en.target)}})},{threshold:0.08});
  els.forEach(function(e){io.observe(e)});
  document.querySelectorAll('.wrk-faq__q').forEach(function(btn){
    btn.addEventListener('click',function(){
      var item=btn.closest('.wrk-faq__item'),answer=item.querySelector('.wrk-faq__a'),isOpen=item.classList.contains('wrk-faq__item--open');
      document.querySelectorAll('.wrk-faq__item--open').forEach(function(o){o.classList.remove('wrk-faq__item--open');o.querySelector('.wrk-faq__q').setAttribute('aria-expanded','false');o.querySelector('.wrk-faq__a').style.maxHeight='0'});
      if(!isOpen){item.classList.add('wrk-faq__item--open');btn.setAttribute('aria-expanded','true');answer.style.maxHeight=answer.scrollHeight+'px'}
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
